import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources: any = {
  en: {
    translation: {
      common: {
        save: 'Save',
        cancel: 'Cancel',
      },
      profile: {
        title: 'My Profile',
        basicInfo: 'Basic Information',
        role: 'Role',
        roleHelp: 'Role cannot be modified',
        username: 'Username',
        email: 'Email',
        preferredLanguage: 'Preferred language',
        nextcloud: 'Nextcloud Settings',
        nextcloudUser: 'Nextcloud User',
        nextcloudPassword: 'Nextcloud Password',
        nextcloudFolder: 'Nextcloud Folder',
        columns: 'Columns Configuration',
        nifColumn: 'NIF Column',
        nameColumn: 'Name Column',
        emailColumn: 'Email Column',
        phoneColumn: 'Phone Column',
        linkExpirationDays: 'Link expiration days',
        systemInfo: 'System Information',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        saving: 'Saving...',
        saveChanges: 'Save Changes',
        success: 'Profile updated successfully',
        loadError: 'Error loading profile',
        updateError: 'Error updating profile',
      },
      login: {
        title: 'Sign in',
        username: 'Username or email',
        password: 'Password',
        signIn: 'Sign in',
        error: 'Incorrect credentials. Try again.',
        subtitle: 'Access the file upload system',
        hint: 'Try with: admin / password',
        expired: 'Your session has expired. Please sign in again.'
      }
    }
  },
  // Header & Sidebar translations
  es: {
    translation: {
      common: {
        save: 'Guardar',
        cancel: 'Cancelar',
      },
      profile: {
        title: 'Mi Perfil',
        basicInfo: 'Información Básica',
        role: 'Rol',
        roleHelp: 'El rol no se puede modificar',
        username: 'Nombre de usuario',
        email: 'Email',
        preferredLanguage: 'Idioma preferido',
        nextcloud: 'Configuración de Nextcloud',
        nextcloudUser: 'Usuario de Nextcloud',
        nextcloudPassword: 'Contraseña de Nextcloud',
        nextcloudFolder: 'Carpeta de Nextcloud',
        columns: 'Configuración de Columnas',
        nifColumn: 'Columna NIF',
        nameColumn: 'Columna Nombre',
        emailColumn: 'Columna Email',
        phoneColumn: 'Columna Teléfono',
        linkExpirationDays: 'Días de expiración de enlaces',
        systemInfo: 'Información del Sistema',
        createdAt: 'Fecha de creación',
        updatedAt: 'Última actualización',
        saving: 'Guardando...',
        saveChanges: 'Guardar Cambios',
        success: 'Perfil actualizado correctamente',
        loadError: 'Error al cargar el perfil',
        updateError: 'Error al actualizar el perfil',
      },
      login: {
        title: 'Iniciar sesión',
        username: 'Usuario o email',
        password: 'Contraseña',
        signIn: 'Entrar',
        error: 'Credenciales incorrectas. Inténtalo de nuevo.',
        subtitle: 'Accede al sistema de carga de archivos',
        hint: 'Prueba con: admin / password',
        expired: 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.'
      }
    }
  },
  de: {
    translation: {
      common: { save: 'Speichern', cancel: 'Abbrechen' },
      profile: {
        title: 'Mein Profil',
        basicInfo: 'Grundlegende Informationen',
        role: 'Rolle',
        roleHelp: 'Die Rolle kann nicht geändert werden',
        username: 'Benutzername',
        email: 'E-Mail',
        preferredLanguage: 'Bevorzugte Sprache',
        nextcloud: 'Nextcloud Einstellungen',
        nextcloudUser: 'Nextcloud Benutzer',
        nextcloudPassword: 'Nextcloud Passwort',
        nextcloudFolder: 'Nextcloud Ordner',
        columns: 'Spaltenkonfiguration',
        nifColumn: 'NIF Spalte',
        nameColumn: 'Namensspalte',
        emailColumn: 'E-Mail-Spalte',
        phoneColumn: 'Telefonspalte',
        linkExpirationDays: 'Ablauf in Tagen',
        systemInfo: 'Systeminformationen',
        createdAt: 'Erstellt am',
        updatedAt: 'Aktualisiert am',
        saving: 'Speichern...',
        saveChanges: 'Änderungen speichern',
        success: 'Profil erfolgreich aktualisiert',
        loadError: 'Fehler beim Laden des Profils',
        updateError: 'Fehler beim Aktualisieren des Profils',
      },
      login: { title: 'Anmelden', username: 'Benutzername oder E-Mail', password: 'Passwort', signIn: 'Anmelden', error: 'Falsche Anmeldedaten. Bitte erneut versuchen.', subtitle: 'Greifen Sie auf das Datei-Uploads-System zu', hint: 'Versuchen Sie: admin / password', expired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.' }
    }
  },
  fr: {
    translation: {
      common: { save: 'Enregistrer', cancel: 'Annuler' },
      profile: {
        title: 'Mon profil',
        basicInfo: 'Informations de base',
        role: 'Rôle',
        roleHelp: 'Le rôle ne peut pas être modifié',
        username: 'Nom d’utilisateur',
        email: 'Email',
        preferredLanguage: 'Langue préférée',
        nextcloud: 'Paramètres Nextcloud',
        nextcloudUser: 'Utilisateur Nextcloud',
        nextcloudPassword: 'Mot de passe Nextcloud',
        nextcloudFolder: 'Dossier Nextcloud',
        columns: 'Configuration des colonnes',
        nifColumn: 'Colonne NIF',
        nameColumn: 'Colonne Nom',
        emailColumn: 'Colonne Email',
        phoneColumn: 'Colonne Téléphone',
        linkExpirationDays: 'Jours d’expiration du lien',
        systemInfo: 'Informations système',
        createdAt: 'Créé le',
        updatedAt: 'Mis à jour le',
        saving: 'Enregistrement...',
        saveChanges: 'Enregistrer les modifications',
        success: 'Profil mis à jour avec succès',
        loadError: 'Erreur lors du chargement du profil',
        updateError: 'Erreur lors de la mise à jour du profil',
      },
      login: { title: 'Se connecter', username: 'Nom d’utilisateur ou email', password: 'Mot de passe', signIn: 'Se connecter', error: 'Identifiants incorrects. Réessayez.', subtitle: "Accédez au système de téléversement de fichiers", hint: 'Essayez avec : admin / password', expired: 'Votre session a expiré. Veuillez vous reconnecter.' }
    }
  }
};

// Add header and sidebar keys for each language
Object.assign(resources.en.translation, {
  common: {
    ...(resources.en.translation.common || {}),
    from: 'From', to: 'To', status: 'Status', all: 'All', correct: 'Correct', incorrect: 'Incorrect', allParen: '(All)',
    file: 'File', user: 'User', records: 'Records', date: 'Date', actions: 'Actions', unknownFile: 'Unknown file', unknownUser: 'Unknown user',
    successful: 'successful', errors: 'errors', summary: 'Summary:', total: 'Total', client: 'Client', nif: 'NIF', view: 'View', close: 'Close',
    created: 'Created', updated: 'Updated', active: 'Active', inactive: 'Inactive', edit: 'Edit', delete: 'Delete', clear: 'Clear', filter: 'Filter', loading: 'Loading...',
    name: 'Name', description: 'Description', confirmDelete: 'Confirm deletion', cannotUndo: 'This action cannot be undone.', changesSaved: 'Changes saved',
    cannotSaveChanges: 'Could not save changes', moveUp: 'Move up', moveDown: 'Move down', filters: 'Filters', search: 'Search...',
    more: 'more', of: 'of', deleteFile: 'Delete File', phone: 'Phone', email: 'Email', apply: 'Apply', sentEmail: 'Sent Email',
    grantorName: 'Grantor Name', responsable: 'Responsible', mainContactEmail: 'Main contact email', campaign: 'Campaign',
  },
  header: { appTitle: 'File Upload System', menu: 'Menu', profile: 'Profile', authenticated: 'Authenticated user', myProfile: 'My profile', logout: 'Sign out', language: 'Language' },
  sidebar: { dashboard: 'Dashboard', upload: 'Upload', excelMapping: 'Excel Mapping', exportCsv: 'CSV Export', templates: 'Templates', users: 'Users', audit: 'Audit Logs', settings: 'Settings', environments: 'Environments', manageFiles: 'Manage Files', manageFilesDashboard: 'Dashboard', manageFilesLoggins: 'Loggins' },
  manageFiles: {
    dashboard: {
      title: 'File Operations Dashboard',
      newOperation: 'New Operation',
      totalOperations: 'Total Operations',
      completedOperations: 'Completed',
      failedOperations: 'Failed',
      totalFiles: 'Total Files',
      processedFiles: 'Processed',
      errorFiles: 'Errors'
    },
    table: {
      id: 'ID',
      directoryPath: 'Directory Path',
      status: 'Status',
      totalFiles: 'Total Files',
      processedFiles: 'Processed',
      errorFiles: 'Errors',
      user: 'User',
      createdAt: 'Created At',
      search: 'Search...',
      noData: 'No operations found'
    },
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      completedWithErrors: 'Completed with Errors',
      failed: 'Failed'
    },
    detail: {
      title: 'Operation Details',
      directoryPath: 'Directory Path',
      status: 'Status',
      totalFiles: 'Total Files',
      processedFiles: 'Processed Files',
      errorFiles: 'Error Files',
      nifCifGroups: 'NIF/CIF Groups',
      nifCif: 'NIF/CIF',
      fileCount: 'Files',
      actions: 'Actions',
      filesInGroup: 'Files in this group',
      fileName: 'File Name',
      fileType: 'Type',
      fileSize: 'Size',
      nextcloudPath: 'Nextcloud Path',
      errors: 'File Errors',
      errorType: 'Error Type',
      errorMessage: 'Error Message',
      extractedNif: 'Extracted NIF',
      createdAt: 'Created At',
      noData: 'No data available for this operation',
      error: {
        fileName: 'File Name',
        errorType: 'Error Type',
        errorMessage: 'Error Message',
        extractedNif: 'Extracted NIF'
      }
    },
    process: {
      title: 'Process Directory',
      selectDirectory: 'Select Directory to Process',
      directoryPath: 'Directory Path',
      directoryPathHelp: 'Enter the full path to the directory containing files to process',
      supportedFormats: 'Supported formats',
      startProcessing: 'Start Processing',
      processing: 'Processing...',
      processingMessage: 'Scanning directory and processing files...',
      result: 'Processing Result',
      successMessage: 'Directory processing started successfully',
      operationId: 'Operation ID',
      viewDashboard: 'View Dashboard',
      supportedFiles: 'Supported Files Found',
      noFilesFound: 'No supported files found in the directory',
      processInfo: 'Process Information',
      step1: 'Scan directory for supported files',
      step2: 'Extract content from each file',
      step3: 'Search for NIF/CIF patterns in content',
      step4: 'Upload files to Nextcloud organized by NIF/CIF',
      warnings: 'Important Notes',
      warning1: 'Make sure the directory path is accessible and contains supported file types',
      warning2: 'Processing may take time depending on the number and size of files',
      currentDirectory: 'Current Directory',
      directories: 'Directories',
      files: 'Files',
      parentDirectory: 'Parent Directory',
      rootDirectory: 'Root Directory',
      notAccessible: 'Not accessible',
      emptyDirectory: 'This directory is empty',
      selectThisDirectory: 'Select This Directory',
      browseDirectory: 'Browse Directory',
      selectDirectoryDescription: 'Select a directory from your computer to process files',
      selectDirectoryButton: 'Select Directory',
      scanning: 'Scanning...',
      selectedDirectory: 'Selected Directory',
      filesInDirectory: 'Files in Directory',
      noSupportedFiles: 'No supported files found in this directory',
      confirmSelection: 'Confirm Selection',
      selectDifferentDirectory: 'Select Different Directory',
      browserNotSupported: 'Your browser does not support directory selection. Please use Chrome, Edge, or Opera.',
      fullPathLabel: 'Full Directory Path',
      fullPathPlaceholder: 'Enter the complete path to the selected directory',
      fullPathHelper: 'Enter the complete path to the selected directory',
      nifDetectionMode: 'NIF/CIF Detection Mode',
      nifDetectionModeHelp: 'Choose how to detect NIF/CIF in files',
      nifInFilename: 'In filename (any file type)',
      nifInContent: 'In file content (supported formats only)',
      supportedFormatsAll: 'All file types supported',
      supportedFormatsContent: 'Supported formats for content reading',
      testProcessing: 'Test Processing',
      testing: 'Testing...',
      testProcessingDescription: 'Simulate processing to preview results without uploading to Nextcloud',
      testResults: 'Test Results',
      testResultsDescription: 'Preview of what would happen if you process this directory',
      totalFilesInDirectory: 'Total Files in Directory',
      totalFilesProcessed: 'Files Processed',
      correctFiles: 'Correct Files',
      errorFiles: 'Error Files',
      unprocessedFiles: 'Unprocessed Files',
      exportResults: 'Export Results to Excel',
      fileName: 'File Name',
      extractedNif: 'Extracted NIF',
      errorType: 'Error Type',
      errorMessage: 'Error Message',
      reason: 'Reason',
      noTestResults: 'No test results available',
      testCompleted: 'Test completed successfully',
      errors: {
        noDirectory: 'Please enter a directory path',
        generic: 'An error occurred while processing the directory'
      }
    }
  }
});
Object.assign(resources.es.translation, {
  common: {
    ...(resources.es.translation.common || {}),
    from: 'Desde', to: 'Hasta', status: 'Estado', all: 'Todos', correct: 'Correcto', incorrect: 'Incorrecto', allParen: '(Todas)',
    file: 'Archivo', user: 'Usuario', records: 'Registros', date: 'Fecha', actions: 'Acciones', unknownFile: 'Archivo desconocido', unknownUser: 'Usuario desconocido',
    successful: 'exitosos', errors: 'errores', summary: 'Resumen:', total: 'Total', client: 'Cliente', nif: 'NIF', view: 'Ver', close: 'Cerrar',
    created: 'Creado', updated: 'Actualizado', active: 'Activo', inactive: 'Inactivo', edit: 'Editar', delete: 'Eliminar', filter: 'Filtro', loading: 'Cargando...',
    name: 'Nombre', description: 'Descripción', confirmDelete: 'Confirmar eliminación', cannotUndo: 'Esta acción no se puede deshacer.', changesSaved: 'Cambios guardados',
    cannotSaveChanges: 'No se pudo guardar cambios', moveUp: 'Subir', moveDown: 'Bajar', filters: 'Filtros', search: 'Buscar...',
    more: 'más', of: 'de', deleteFile: 'Eliminar archivo', phone: 'Teléfono', email: 'Email', apply: 'Aplicar', sentEmail: 'Email Enviado',
    grantorName: 'Grantor Name', responsable: 'Responsable', mainContactEmail: 'Email de contacto principal', campaign: 'Campaña',
  },
  header: { appTitle: 'Sistema de Carga de Archivos', menu: 'Menú', profile: 'Perfil', authenticated: 'Usuario autenticado', myProfile: 'Mi perfil', logout: 'Cerrar Sesión', language: 'Idioma' },
  sidebar: { dashboard: 'Dashboard', upload: 'Subir Archivo', excelMapping: 'Mapeo Excel', exportCsv: 'Exportación CSV', templates: 'Plantillas', users: 'Usuarios', audit: 'Auditoría', settings: 'Configuraciones', environments: 'Entornos', manageFiles: 'Gestionar Archivos', manageFilesDashboard: 'Dashboard', manageFilesLoggins: 'Loggins' },
  manageFiles: {
    dashboard: {
      title: 'Panel de Operaciones de Archivos',
      newOperation: 'Nueva Operación',
      totalOperations: 'Total Operaciones',
      completedOperations: 'Completadas',
      failedOperations: 'Fallidas',
      totalFiles: 'Total Archivos',
      processedFiles: 'Procesados',
      errorFiles: 'Errores'
    },
    table: {
      id: 'ID',
      directoryPath: 'Ruta del Directorio',
      status: 'Estado',
      totalFiles: 'Total Archivos',
      processedFiles: 'Procesados',
      errorFiles: 'Errores',
      user: 'Usuario',
      createdAt: 'Fecha de Creación',
      search: 'Buscar...',
      noData: 'No se encontraron operaciones'
    },
    status: {
      pending: 'Pendiente',
      processing: 'Procesando',
      completed: 'Completado',
      completedWithErrors: 'Completado con Errores',
      failed: 'Fallido'
    },
    detail: {
      title: 'Detalles de la Operación',
      directoryPath: 'Ruta del Directorio',
      status: 'Estado',
      totalFiles: 'Total Archivos',
      processedFiles: 'Archivos Procesados',
      errorFiles: 'Archivos con Error',
      nifCifGroups: 'Grupos NIF/CIF',
      nifCif: 'NIF/CIF',
      fileCount: 'Archivos',
      actions: 'Acciones',
      filesInGroup: 'Archivos en este grupo',
      fileName: 'Nombre del Archivo',
      fileType: 'Tipo',
      fileSize: 'Tamaño',
      nextcloudPath: 'Ruta en Nextcloud',
      errors: 'Errores de Archivos',
      errorType: 'Tipo de Error',
      errorMessage: 'Mensaje de Error',
      extractedNif: 'NIF Extraído',
      createdAt: 'Fecha de Creación',
      noData: 'No hay datos disponibles para esta operación',
      error: {
        fileName: 'Nombre del Archivo',
        errorType: 'Tipo de Error',
        errorMessage: 'Mensaje de Error',
        extractedNif: 'NIF Extraído'
      }
    },
    process: {
      title: 'Procesar Directorio',
      selectDirectory: 'Seleccionar Directorio a Procesar',
      directoryPath: 'Ruta del Directorio',
      directoryPathHelp: 'Introduce la ruta completa al directorio que contiene los archivos a procesar',
      supportedFormats: 'Formatos soportados',
      startProcessing: 'Iniciar Procesamiento',
      processing: 'Procesando...',
      processingMessage: 'Escaneando directorio y procesando archivos...',
      result: 'Resultado del Procesamiento',
      successMessage: 'Procesamiento del directorio iniciado correctamente',
      operationId: 'ID de Operación',
      viewDashboard: 'Ver Panel',
      supportedFiles: 'Archivos Soportados Encontrados',
      noFilesFound: 'No se encontraron archivos soportados en el directorio',
      processInfo: 'Información del Proceso',
      step1: 'Escanear directorio en busca de archivos soportados',
      step2: 'Extraer contenido de cada archivo',
      step3: 'Buscar patrones de NIF/CIF en el contenido',
      step4: 'Subir archivos a Nextcloud organizados por NIF/CIF',
      warnings: 'Notas Importantes',
      warning1: 'Asegúrate de que la ruta del directorio sea accesible y contenga tipos de archivo soportados',
      warning2: 'El procesamiento puede tomar tiempo dependiendo del número y tamaño de los archivos',
      currentDirectory: 'Directorio Actual',
      directories: 'Directorios',
      files: 'Archivos',
      parentDirectory: 'Directorio Padre',
      rootDirectory: 'Directorio Raíz',
      notAccessible: 'No accesible',
      emptyDirectory: 'Este directorio está vacío',
      selectThisDirectory: 'Seleccionar Este Directorio',
      browseDirectory: 'Explorar Directorio',
      selectDirectoryDescription: 'Selecciona un directorio de tu computadora para procesar archivos',
      selectDirectoryButton: 'Seleccionar Directorio',
      scanning: 'Escaneando...',
      selectedDirectory: 'Directorio Seleccionado',
      filesInDirectory: 'Archivos en el Directorio',
      noSupportedFiles: 'No se encontraron archivos compatibles en este directorio',
      confirmSelection: 'Confirmar Selección',
      selectDifferentDirectory: 'Seleccionar Otro Directorio',
      browserNotSupported: 'Tu navegador no soporta la selección de directorios. Por favor usa Chrome, Edge u Opera.',
      fullPathLabel: 'Ruta Completa del Directorio',
      fullPathPlaceholder: 'Ingresa la ruta completa del directorio seleccionado',
      fullPathHelper: 'Ingresa la ruta completa del directorio seleccionado',
      nifDetectionMode: 'Modo de Detección NIF/CIF',
      nifDetectionModeHelp: 'Elige cómo detectar NIF/CIF en los archivos',
      nifInFilename: 'En nombre del archivo (cualquier tipo)',
      nifInContent: 'En contenido del archivo (solo formatos soportados)',
      supportedFormatsAll: 'Todos los tipos de archivo soportados',
      supportedFormatsContent: 'Formatos soportados para lectura de contenido',
      testProcessing: 'Probar Procesamiento',
      testing: 'Probando...',
      testProcessingDescription: 'Simular procesamiento para previsualizar resultados sin subir a Nextcloud',
      testResults: 'Resultados del Test',
      testResultsDescription: 'Vista previa de lo que ocurriría si procesas este directorio',
      totalFilesInDirectory: 'Total Archivos en Directorio',
      totalFilesProcessed: 'Archivos Procesados',
      correctFiles: 'Archivos Correctos',
      errorFiles: 'Archivos con Error',
      unprocessedFiles: 'Archivos No Procesados',
      exportResults: 'Exportar Resultados a Excel',
      fileName: 'Nombre del Archivo',
      extractedNif: 'NIF Extraído',
      errorType: 'Tipo de Error',
      errorMessage: 'Mensaje de Error',
      reason: 'Motivo',
      noTestResults: 'No hay resultados de test disponibles',
      testCompleted: 'Test completado exitosamente',
      errors: {
        noDirectory: 'Por favor, introduce una ruta de directorio',
        generic: 'Ocurrió un error al procesar el directorio'
      }
    }
  }
});
Object.assign(resources.de.translation, {
  common: {
    ...(resources.de.translation.common || {}),
    from: 'Von', to: 'Bis', status: 'Status', all: 'Alle', correct: 'Korrekt', incorrect: 'Inkorrekt', allParen: '(Alle)',
    file: 'Datei', user: 'Benutzer', records: 'Einträge', date: 'Datum', actions: 'Aktionen', unknownFile: 'Unbekannte Datei', unknownUser: 'Unbekannter Benutzer',
    successful: 'erfolgreich', errors: 'Fehler', summary: 'Zusammenfassung:', total: 'Gesamt', client: 'Kunde', nif: 'NIF', view: 'Ansehen', close: 'Schließen',
    created: 'Erstellt', updated: 'Aktualisiert', active: 'Aktiv', inactive: 'Inaktiv', edit: 'Bearbeiten', delete: 'Löschen', filter: 'Filter', loading: 'Laden...',
    name: 'Name', description: 'Beschreibung', confirmDelete: 'Löschen bestätigen', cannotUndo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    changesSaved: 'Änderungen gespeichert', cannotSaveChanges: 'Änderungen konnten nicht gespeichert werden', moveUp: 'Nach oben', moveDown: 'Nach unten', filters: 'Filter', search: 'Suchen...',
    more: 'mehr', of: 'von', deleteFile: 'Datei löschen', phone: 'Telefon', email: 'E-Mail', apply: 'Anwenden', sentEmail: 'E-Mail gesendet',
    grantorName: 'Grantor Name', responsable: 'Verantwortlich', mainContactEmail: 'Hauptkontakt-E-Mail', campaign: 'Kampagne',
  },
  header: { appTitle: 'Datei-Upload-System', menu: 'Menü', profile: 'Profil', authenticated: 'Authentifizierter Benutzer', myProfile: 'Mein Profil', logout: 'Abmelden', language: 'Sprache' },
  sidebar: { dashboard: 'Dashboard', upload: 'Hochladen', excelMapping: 'Excel-Zuordnung', exportCsv: 'CSV-Export', templates: 'Vorlagen', users: 'Benutzer', audit: 'Audit-Protokolle', settings: 'Einstellungen', environments: 'Umgebungen', manageFiles: 'Dateien verwalten', manageFilesDashboard: 'Dashboard', manageFilesLoggins: 'Loggins' },
  manageFiles: {
    dashboard: {
      title: 'Datei-Operationen Dashboard',
      newOperation: 'Neue Operation',
      totalOperations: 'Gesamt Operationen',
      completedOperations: 'Abgeschlossen',
      failedOperations: 'Fehlgeschlagen',
      totalFiles: 'Gesamt Dateien',
      processedFiles: 'Verarbeitet',
      errorFiles: 'Fehler'
    },
    table: {
      id: 'ID',
      directoryPath: 'Verzeichnispfad',
      status: 'Status',
      totalFiles: 'Gesamt Dateien',
      processedFiles: 'Verarbeitet',
      errorFiles: 'Fehler',
      user: 'Benutzer',
      createdAt: 'Erstellt am',
      search: 'Suchen...',
      noData: 'Keine Operationen gefunden'
    },
    status: {
      pending: 'Ausstehend',
      processing: 'Verarbeitung',
      completed: 'Abgeschlossen',
      completedWithErrors: 'Abgeschlossen mit Fehlern',
      failed: 'Fehlgeschlagen'
    },
    detail: {
      title: 'Operationsdetails',
      directoryPath: 'Verzeichnispfad',
      status: 'Status',
      totalFiles: 'Gesamt Dateien',
      processedFiles: 'Verarbeitete Dateien',
      errorFiles: 'Fehlerhafte Dateien',
      errors: 'Dateifehler',
      error: {
        fileName: 'Dateiname',
        errorType: 'Fehlertyp',
        errorMessage: 'Fehlermeldung',
        extractedNif: 'Extrahierte NIF'
      }
    },
    process: {
      title: 'Verzeichnis verarbeiten',
      selectDirectory: 'Verzeichnis zur Verarbeitung auswählen',
      directoryPath: 'Verzeichnispfad',
      directoryPathHelp: 'Geben Sie den vollständigen Pfad zum Verzeichnis mit zu verarbeitenden Dateien ein',
      supportedFormats: 'Unterstützte Formate',
      startProcessing: 'Verarbeitung starten',
      processing: 'Verarbeitung...',
      processingMessage: 'Verzeichnis scannen und Dateien verarbeiten...',
      result: 'Verarbeitungsergebnis',
      successMessage: 'Verzeichnisverarbeitung erfolgreich gestartet',
      operationId: 'Operations-ID',
      viewDashboard: 'Dashboard anzeigen',
      supportedFiles: 'Gefundene unterstützte Dateien',
      noFilesFound: 'Keine unterstützten Dateien im Verzeichnis gefunden',
      processInfo: 'Prozessinformationen',
      step1: 'Verzeichnis nach unterstützten Dateien scannen',
      step2: 'Inhalt aus jeder Datei extrahieren',
      step3: 'Nach NIF/CIF-Mustern im Inhalt suchen',
      step4: 'Dateien nach NIF/CIF organisiert zu Nextcloud hochladen',
      warnings: 'Wichtige Hinweise',
      warning1: 'Stellen Sie sicher, dass der Verzeichnispfad zugänglich ist und unterstützte Dateitypen enthält',
      warning2: 'Die Verarbeitung kann je nach Anzahl und Größe der Dateien Zeit in Anspruch nehmen',
      currentDirectory: 'Aktuelles Verzeichnis',
      directories: 'Verzeichnisse',
      files: 'Dateien',
      parentDirectory: 'Übergeordnetes Verzeichnis',
      rootDirectory: 'Stammverzeichnis',
      notAccessible: 'Nicht zugänglich',
      emptyDirectory: 'Dieses Verzeichnis ist leer',
      selectThisDirectory: 'Dieses Verzeichnis auswählen',
      browseDirectory: 'Verzeichnis durchsuchen',
      selectDirectoryDescription: 'Wählen Sie ein Verzeichnis von Ihrem Computer aus, um Dateien zu verarbeiten',
      selectDirectoryButton: 'Verzeichnis auswählen',
      scanning: 'Scannen...',
      selectedDirectory: 'Ausgewähltes Verzeichnis',
      filesInDirectory: 'Dateien im Verzeichnis',
      noSupportedFiles: 'Keine unterstützten Dateien in diesem Verzeichnis gefunden',
      confirmSelection: 'Auswahl bestätigen',
      selectDifferentDirectory: 'Anderes Verzeichnis auswählen',
      browserNotSupported: 'Ihr Browser unterstützt keine Verzeichnisauswahl. Bitte verwenden Sie Chrome, Edge oder Opera.',
      fullPathLabel: 'Vollständiger Verzeichnispfad',
      fullPathPlaceholder: 'Geben Sie den vollständigen Pfad zum ausgewählten Verzeichnis ein',
      fullPathHelper: 'Geben Sie den vollständigen Pfad zum ausgewählten Verzeichnis ein',
      nifDetectionMode: 'NIF/CIF-Erkennungsmodus',
      nifDetectionModeHelp: 'Wählen Sie, wie NIF/CIF in Dateien erkannt werden soll',
      nifInFilename: 'Im Dateinamen (jeder Dateityp)',
      nifInContent: 'Im Dateiinhalt (nur unterstützte Formate)',
      supportedFormatsAll: 'Alle Dateitypen unterstützt',
      supportedFormatsContent: 'Unterstützte Formate für Inhaltslesung',
      testProcessing: 'Verarbeitung testen',
      testProcessingDescription: 'Verarbeitung simulieren, um Ergebnisse ohne Upload zu Nextcloud zu überprüfen',
      testResults: 'Testergebnisse',
      testResultsDescription: 'Vorschau dessen, was passieren würde, wenn Sie dieses Verzeichnis verarbeiten',
      totalFilesInDirectory: 'Gesamt Dateien im Verzeichnis',
      totalFilesProcessed: 'Verarbeitete Dateien',
      correctFiles: 'Korrekte Dateien',
      errorFiles: 'Fehlerhafte Dateien',
      unprocessedFiles: 'Nicht verarbeitete Dateien',
      exportResults: 'Ergebnisse nach Excel exportieren',
      fileName: 'Dateiname',
      extractedNif: 'Extrahierte NIF',
      errorType: 'Fehlertyp',
      errorMessage: 'Fehlermeldung',
      noTestResults: 'Keine Testergebnisse verfügbar',
      testCompleted: 'Test erfolgreich abgeschlossen',
      errors: {
        noDirectory: 'Bitte geben Sie einen Verzeichnispfad ein',
        generic: 'Ein Fehler ist beim Verarbeiten des Verzeichnisses aufgetreten'
      }
    }
  }
});
Object.assign(resources.fr.translation, {
  common: {
    ...(resources.fr.translation.common || {}),
    from: 'De', to: 'À', status: 'Statut', all: 'Tous', correct: 'Correct', incorrect: 'Incorrect', allParen: '(Toutes)',
    file: 'Fichier', user: 'Utilisateur', records: 'Enregistrements', date: 'Date', actions: 'Actions', unknownFile: 'Fichier inconnu', unknownUser: 'Utilisateur inconnu',
    successful: 'réussis', errors: 'erreurs', summary: 'Résumé :', total: 'Total', client: 'Client', nif: 'NIF', view: 'Voir', close: 'Fermer',
    created: 'Créé', updated: 'Mis à jour', active: 'Actif', inactive: 'Inactif', edit: 'Modifier', delete: 'Supprimer', filter: 'Filtre', loading: 'Chargement...',
    name: 'Nom', description: 'Description', confirmDelete: 'Confirmer la suppression', cannotUndo: 'Cette action est irréversible.', changesSaved: 'Modifications enregistrées',
    cannotSaveChanges: 'Impossible d\'enregistrer les modifications', moveUp: 'Monter', moveDown: 'Descendre', filters: 'Filtres', search: 'Rechercher...',
    more: 'plus', of: 'de', deleteFile: 'Supprimer le fichier', phone: 'Téléphone', email: 'Email', apply: 'Appliquer', sentEmail: 'Email envoyé',
    grantorName: 'Grantor Name', responsable: 'Responsable', mainContactEmail: 'Email de contact principal', campaign: 'Campagne',
  },
  header: { appTitle: 'Système de téléversement de fichiers', menu: 'Menu', profile: 'Profil', authenticated: 'Utilisateur authentifié', myProfile: 'Mon profil', logout: 'Se déconnecter', language: 'Langue' },
  sidebar: { dashboard: 'Tableau de bord', upload: 'Téléverser', excelMapping: 'Mappage Excel', exportCsv: 'Export CSV', templates: 'Modèles', users: 'Utilisateurs', audit: 'Journaux d\'audit', settings: 'Paramètres', environments: 'Environnements', manageFiles: 'Gérer les fichiers', manageFilesDashboard: 'Tableau de bord', manageFilesLoggins: 'Loggins' },
  manageFiles: {
    dashboard: {
      title: 'Tableau de bord des opérations de fichiers',
      newOperation: 'Nouvelle opération',
      totalOperations: 'Total opérations',
      completedOperations: 'Terminées',
      failedOperations: 'Échouées',
      totalFiles: 'Total fichiers',
      processedFiles: 'Traités',
      errorFiles: 'Erreurs'
    },
    table: {
      id: 'ID',
      directoryPath: 'Chemin du répertoire',
      status: 'Statut',
      totalFiles: 'Total fichiers',
      processedFiles: 'Traités',
      errorFiles: 'Erreurs',
      user: 'Utilisateur',
      createdAt: 'Créé le',
      search: 'Rechercher...',
      noData: 'Aucune opération trouvée'
    },
    status: {
      pending: 'En attente',
      processing: 'Traitement',
      completed: 'Terminé',
      completedWithErrors: 'Terminé avec erreurs',
      failed: 'Échoué'
    },
    detail: {
      title: 'Détails de l\'opération',
      directoryPath: 'Chemin du répertoire',
      status: 'Statut',
      totalFiles: 'Total fichiers',
      processedFiles: 'Fichiers traités',
      errorFiles: 'Fichiers en erreur',
      errors: 'Erreurs de fichiers',
      error: {
        fileName: 'Nom du fichier',
        errorType: 'Type d\'erreur',
        errorMessage: 'Message d\'erreur',
        extractedNif: 'NIF extrait'
      }
    },
    process: {
      title: 'Traiter le répertoire',
      selectDirectory: 'Sélectionner le répertoire à traiter',
      directoryPath: 'Chemin du répertoire',
      directoryPathHelp: 'Entrez le chemin complet vers le répertoire contenant les fichiers à traiter',
      supportedFormats: 'Formats supportés',
      startProcessing: 'Démarrer le traitement',
      processing: 'Traitement...',
      processingMessage: 'Scan du répertoire et traitement des fichiers...',
      result: 'Résultat du traitement',
      successMessage: 'Traitement du répertoire démarré avec succès',
      operationId: 'ID de l\'opération',
      viewDashboard: 'Voir le tableau de bord',
      supportedFiles: 'Fichiers supportés trouvés',
      noFilesFound: 'Aucun fichier supporté trouvé dans le répertoire',
      processInfo: 'Informations du processus',
      step1: 'Scanner le répertoire pour les fichiers supportés',
      step2: 'Extraire le contenu de chaque fichier',
      step3: 'Rechercher les motifs NIF/CIF dans le contenu',
      step4: 'Téléverser les fichiers vers Nextcloud organisés par NIF/CIF',
      warnings: 'Notes importantes',
      warning1: 'Assurez-vous que le chemin du répertoire est accessible et contient des types de fichiers supportés',
      warning2: 'Le traitement peut prendre du temps selon le nombre et la taille des fichiers',
      currentDirectory: 'Répertoire Actuel',
      directories: 'Répertoires',
      files: 'Fichiers',
      parentDirectory: 'Répertoire Parent',
      rootDirectory: 'Répertoire Racine',
      notAccessible: 'Non accessible',
      emptyDirectory: 'Ce répertoire est vide',
      selectThisDirectory: 'Sélectionner Ce Répertoire',
      browseDirectory: 'Parcourir le Répertoire',
      selectDirectoryDescription: 'Sélectionnez un répertoire de votre ordinateur pour traiter les fichiers',
      selectDirectoryButton: 'Sélectionner le Répertoire',
      scanning: 'Scan en cours...',
      selectedDirectory: 'Répertoire Sélectionné',
      filesInDirectory: 'Fichiers dans le Répertoire',
      noSupportedFiles: 'Aucun fichier supporté trouvé dans ce répertoire',
      confirmSelection: 'Confirmer la Sélection',
      selectDifferentDirectory: 'Sélectionner un Autre Répertoire',
      browserNotSupported: 'Votre navigateur ne prend pas en charge la sélection de répertoires. Veuillez utiliser Chrome, Edge ou Opera.',
      fullPathLabel: 'Chemin complet du répertoire',
      fullPathPlaceholder: 'Entrez le chemin complet du répertoire sélectionné',
      fullPathHelper: 'Entrez le chemin complet du répertoire sélectionné',
      nifDetectionMode: 'Mode de détection NIF/CIF',
      nifDetectionModeHelp: 'Choisissez comment détecter NIF/CIF dans les fichiers',
      nifInFilename: 'Dans le nom du fichier (tout type de fichier)',
      nifInContent: 'Dans le contenu du fichier (formats supportés uniquement)',
      supportedFormatsAll: 'Tous les types de fichiers supportés',
      supportedFormatsContent: 'Formats supportés pour la lecture du contenu',
      testProcessing: 'Tester le traitement',
      testProcessingDescription: 'Simuler le traitement pour prévisualiser les résultats sans téléverser vers Nextcloud',
      testResults: 'Résultats du test',
      testResultsDescription: 'Aperçu de ce qui se passerait si vous traitez ce répertoire',
      totalFilesInDirectory: 'Total fichiers dans le répertoire',
      totalFilesProcessed: 'Fichiers traités',
      correctFiles: 'Fichiers corrects',
      errorFiles: 'Fichiers en erreur',
      unprocessedFiles: 'Fichiers non traités',
      exportResults: 'Exporter les résultats vers Excel',
      fileName: 'Nom du fichier',
      extractedNif: 'NIF extrait',
      errorType: 'Type d\'erreur',
      errorMessage: 'Message d\'erreur',
      noTestResults: 'Aucun résultat de test disponible',
      testCompleted: 'Test terminé avec succès',
      errors: {
        noDirectory: 'Veuillez entrer un chemin de répertoire',
        generic: 'Une erreur s\'est produite lors du traitement du répertoire'
      }
    }
  }
});

// Upload page translations
Object.assign(resources.en.translation, {
  upload: {
    title: 'Upload Excel File',
    mappingConfig: 'Mapping Configuration',
    selectMapping: 'Select a mapping configuration',
    selectedConfig: 'Selected configuration',
    selectFile: 'Select an Excel file to process',
    ariaSelectFile: 'Select Excel file',
    fileSelected: 'File selected',
    clickToSelect: 'Click to select a file',
    supportedFormats: 'Supported formats: .xlsx, .xls',
    size: 'Size',
    processing: 'Processing file...',
    processingShort: 'Processing...',
    uploadAndProcess: 'Upload and Process',
    info: {
      title: 'Processing information',
      supportedTitle: 'Supported formats',
      supportedDesc: 'Excel (.xlsx, .xls)',
      autoTitle: 'Automatic processing',
      autoDesc: 'Data is processed automatically upon upload',
      resultsTitle: 'Results',
      resultsDesc: 'Results will appear on the dashboard after processing',
    },
    confirm: {
      title: 'Confirm Processing',
      subtitle: 'Data will be processed with the following configuration:',
      cta: 'Confirm and Process',
      info: 'By confirming, the file will be sent to the server for processing. Data will be processed according to the selected mapping configuration.',
      excludeAndGenerate: 'Exclude duplicates and generate',
    },
    uploading: 'Uploading...',
    checkExistence: 'Check existence (nif + template)',
    existenceFound: 'Clients already processed for the selected template/type were found.',
    name: 'Name',
    description: 'Description',
    excelFile: 'Excel File',
    fieldsCount: 'Configured fields',
    fileToProcess: 'File to Process',
    processingService: 'Processing Service',
    externalService: 'External Service',
    externalServiceBackend: 'It will be sent to the service configured in the backend',
    environment: 'Environment',
    notSelected: 'Not selected',
    errors: {
      noFile: 'Please select an Excel file.',
      noMapping: 'Please select a mapping configuration.',
    },
  }
});

Object.assign(resources.es.translation, {
  upload: {
    title: 'Subir Archivo Excel',
    mappingConfig: 'Configuración de Mapeo',
    selectMapping: 'Selecciona una configuración de mapeo',
    selectedConfig: 'Configuración seleccionada',
    selectFile: 'Selecciona un archivo Excel para procesar',
    ariaSelectFile: 'Seleccionar archivo Excel',
    fileSelected: 'Archivo seleccionado',
    clickToSelect: 'Haz clic para seleccionar un archivo',
    supportedFormats: 'Formatos soportados: .xlsx, .xls',
    size: 'Tamaño',
    processing: 'Procesando archivo...',
    processingShort: 'Procesando...',
    uploadAndProcess: 'Subir y Procesar',
    info: {
      title: 'Información sobre el procesamiento',
      supportedTitle: 'Formatos soportados',
      supportedDesc: 'Excel (.xlsx, .xls)',
      autoTitle: 'Procesamiento automático',
      autoDesc: 'Los datos se procesan automáticamente al subir el archivo',
      resultsTitle: 'Resultados',
      resultsDesc: 'Los resultados aparecerán en el dashboard después del procesamiento',
    },
    confirm: {
      title: 'Confirmar Procesamiento',
      subtitle: 'Se van a procesar los datos con la siguiente configuración:',
      cta: 'Confirmar y Procesar',
      info: 'Al confirmar, el archivo se enviará al servidor para su procesamiento. Los datos se procesarán según la configuración de mapeo seleccionada.',
      excludeAndGenerate: 'Excluir duplicados y generar',
    },
    uploading: 'Subiendo...',
    checkExistence: 'Comprobar existencia (nif + template)',
    existenceFound: 'Se han encontrado clientes ya procesados para el template/tipo seleccionado.',
    name: 'Nombre',
    description: 'Descripción',
    excelFile: 'Archivo Excel',
    fieldsCount: 'Campos configurados',
    fileToProcess: 'Archivo a Procesar',
    processingService: 'Servicio de Procesamiento',
    externalService: 'Servicio Externo',
    externalServiceBackend: 'Se enviará al servicio configurado en el backend',
    environment: 'Entorno',
    notSelected: 'No seleccionado',
    errors: {
      noFile: 'Por favor, selecciona un archivo Excel.',
      noMapping: 'Por favor, selecciona una configuración de mapeo.',
    },
  }
});

// Dashboard translations
Object.assign(resources.en.translation, {
  dashboard: {
    title: 'Dashboard', loading: 'Loading dashboard data...', loadError: 'Error loading dashboard data. Check the service.',
    processedFiles: 'Processed Files', totalRecords: 'Total Records', successfulFiles: 'Successful Files', errorFiles: 'Files with Errors',
    exportCsv: 'Export CSV', campaign: 'Campaign', userUsername: 'User (username)', selectUser: 'Select user', downloadCsv: 'Download CSV',
    mapping: 'Mapping', processingDetails: 'Processing details', configuration: 'Configuration', processedClients: 'Processed clients:',
    duplicateClient: 'Error: Duplicate client', viewShareLink: 'View share link', documents: 'Documents', noData: 'No processed data available',
    uploadFirst: 'Upload your first file to get started!', uploadFile: 'Upload File', generatedDocuments: 'Generated documents',
    noDocuments: 'No generated documents.', preview: 'Preview', downloadPdf: 'Download PDF', downloadDocx: 'Download DOCX', authTo: 'Auth to',
    type: 'Type', generated: 'Generated', uploaded: 'Uploaded', download: 'Download'
  }
});

// Templates page translations
Object.assign(resources.en.translation, {
  templates: {
    title: 'Templates',
    name: 'Name', description: 'Description', category: 'Category', variables: 'Variables', sizeKb: 'Size (KB)',
    totalTemplates: 'Total Templates', active: 'Active', storageUsed: 'Storage Used', categories: 'Categories',
    detail: 'Template Detail', uploadNew: 'Upload New Version', dropHereOrClick: 'Drag file here or click to select (.docx, .doc)',
    browse: 'Browse', noDirectUpload: 'This template does not allow direct upload.', viewEdit: 'View / Update', viewOnly: 'View (read-only)',
    download: 'Download', upload: 'Upload', reportType: 'Report Type'
  }
});
Object.assign(resources.es.translation, {
  templates: {
    title: 'Plantillas',
    name: 'Nombre', description: 'Descripción', category: 'Categoría', variables: 'Variables', sizeKb: 'Tamaño (KB)',
    totalTemplates: 'Total Plantillas', active: 'Activos', storageUsed: 'Espacio Usado', categories: 'Categorías',
    detail: 'Detalle de Plantilla', uploadNew: 'Subir Nueva Versión', dropHereOrClick: 'Arrastra el archivo aquí o haz clic para seleccionar (.docx, .doc)',
    browse: 'Examinar', noDirectUpload: 'Esta plantilla no permite subida directa.', viewEdit: 'Ver / Actualizar', viewOnly: 'Ver (solo lectura)',
    download: 'Descargar', upload: 'Subir', reportType: 'Tipo de Informe'
  }
});
Object.assign(resources.es.translation, {
  dashboard: {
    title: 'Dashboard', loading: 'Cargando datos del Dashboard...', loadError: 'Error al cargar los datos del dashboard. Verifique que el servicio esté funcionando.',
    processedFiles: 'Archivos Procesados', totalRecords: 'Total Registros', successfulFiles: 'Archivos Exitosos', errorFiles: 'Archivos con Errores',
    exportCsv: 'Exportar CSV', campaign: 'Campaña', userUsername: 'Usuario (username)', selectUser: 'Selecciona usuario', downloadCsv: 'Descargar CSV',
    mapping: 'Mapeo', processingDetails: 'Detalles del procesamiento', configuration: 'Configuración', processedClients: 'Clientes procesados:',
    duplicateClient: 'Error: Cliente duplicado', viewShareLink: 'Ver enlace de compartir', documents: 'Documentos', noData: 'No hay datos procesados disponibles',
    uploadFirst: '¡Sube tu primer archivo para comenzar!', uploadFile: 'Subir Archivo', generatedDocuments: 'Documentos generados',
    noDocuments: 'No hay documentos generados.', preview: 'Previsualización', downloadPdf: 'Descargar PDF', downloadDocx: 'Descargar DOCX', authTo: 'Auth to',
    type: 'Tipo', generated: 'Generado', uploaded: 'Subido', download: 'Descargar'
  }
});
Object.assign(resources.de.translation, {
  dashboard: {
    title: 'Dashboard', loading: 'Dashboard-Daten werden geladen...', loadError: 'Fehler beim Laden der Dashboard-Daten. Dienst prüfen.',
    processedFiles: 'Verarbeitete Dateien', totalRecords: 'Gesamteinträge', successfulFiles: 'Erfolgreiche Dateien', errorFiles: 'Dateien mit Fehlern',
    exportCsv: 'CSV exportieren', campaign: 'Kampagne', userUsername: 'Benutzer (Username)', selectUser: 'Benutzer auswählen', downloadCsv: 'CSV herunterladen',
    mapping: 'Zuordnung', processingDetails: 'Verarbeitungsdetails', configuration: 'Konfiguration', processedClients: 'Verarbeitete Kunden:',
    duplicateClient: 'Fehler: Doppelte Kunde', viewShareLink: 'Freigabelink anzeigen', documents: 'Dokumente', noData: 'Keine verarbeiteten Daten verfügbar',
    uploadFirst: 'Laden Sie Ihre erste Datei hoch, um zu beginnen!', uploadFile: 'Datei hochladen', generatedDocuments: 'Erstellte Dokumente',
    noDocuments: 'Keine erstellten Dokumente.', preview: 'Vorschau', downloadPdf: 'PDF herunterladen', downloadDocx: 'DOCX herunterladen', authTo: 'Auth to',
    type: 'Typ', generated: 'Generiert', uploaded: 'Hochgeladen', download: 'Herunterladen'
  }
});
Object.assign(resources.fr.translation, {
  dashboard: {
    title: 'Tableau de bord', loading: 'Chargement des données du tableau de bord...', loadError: 'Erreur lors du chargement des données. Vérifiez le service.',
    processedFiles: 'Fichiers traités', totalRecords: 'Enregistrements totaux', successfulFiles: 'Fichiers réussis', errorFiles: 'Fichiers avec erreurs',
    exportCsv: 'Exporter CSV', campaign: 'Campagne', userUsername: 'Utilisateur (username)', selectUser: 'Sélectionner un utilisateur', downloadCsv: 'Télécharger CSV',
    mapping: 'Mappage', processingDetails: 'Détails du traitement', configuration: 'Configuration', processedClients: 'Clients traités :',
    duplicateClient: 'Erreur : client en double', viewShareLink: 'Voir le lien de partage', documents: 'Documents', noData: 'Aucune donnée traitée disponible',
    uploadFirst: 'Téléversez votre premier fichier pour commencer !', uploadFile: 'Téléverser un fichier', generatedDocuments: 'Documents générés',
    noDocuments: 'Aucun document généré.', preview: 'Aperçu', downloadPdf: 'Télécharger PDF', downloadDocx: 'Télécharger DOCX', authTo: 'Auth to',
    type: 'Type', generated: 'Généré', uploaded: 'Téléversé', download: 'Télécharger'
  }
});

// Users list
Object.assign(resources.en.translation, { users: { title: 'Users', new: 'New User', confirmDelete: 'Delete user?', empty: 'No users' } });
Object.assign(resources.es.translation, { users: { title: 'Usuarios', new: 'Nuevo Usuario', confirmDelete: '¿Eliminar usuario?', empty: 'Sin usuarios' } });
Object.assign(resources.de.translation, { users: { title: 'Benutzer', new: 'Neuer Benutzer', confirmDelete: 'Benutzer löschen?', empty: 'Keine Benutzer' } });
Object.assign(resources.fr.translation, { users: { title: 'Utilisateurs', new: 'Nouvel utilisateur', confirmDelete: 'Supprimer l\'utilisateur ?', empty: 'Aucun utilisateur' } });

// Templates translations for German and French
Object.assign(resources.de.translation, {
  templates: {
    title: 'Vorlagen',
    name: 'Name', description: 'Beschreibung', category: 'Kategorie', variables: 'Variablen', sizeKb: 'Größe (KB)',
    totalTemplates: 'Gesamte Vorlagen', active: 'Aktiv', storageUsed: 'Speicher verwendet', categories: 'Kategorien',
    detail: 'Vorlagen-Details', uploadNew: 'Neue Version hochladen', dropHereOrClick: 'Datei hier ablegen oder klicken zum Auswählen (.docx, .doc)',
    browse: 'Durchsuchen', noDirectUpload: 'Diese Vorlage erlaubt keinen direkten Upload.', viewEdit: 'Anzeigen / Aktualisieren', viewOnly: 'Anzeigen (nur lesen)',
    download: 'Herunterladen', upload: 'Hochladen', reportType: 'Berichtstyp'
  }
});
Object.assign(resources.fr.translation, {
  templates: {
    title: 'Modèles',
    name: 'Nom', description: 'Description', category: 'Catégorie', variables: 'Variables', sizeKb: 'Taille (KB)',
    totalTemplates: 'Total Modèles', active: 'Actifs', storageUsed: 'Espace utilisé', categories: 'Catégories',
    detail: 'Détails du Modèle', uploadNew: 'Téléverser Nouvelle Version', dropHereOrClick: 'Glissez le fichier ici ou cliquez pour sélectionner (.docx, .doc)',
    browse: 'Parcourir', noDirectUpload: 'Ce modèle ne permet pas le téléversement direct.', viewEdit: 'Voir / Mettre à jour', viewOnly: 'Voir (lecture seule)',
    download: 'Télécharger', upload: 'Téléverser', reportType: 'Type de Rapport'
  }
});

// Audit logs
Object.assign(resources.en.translation, { audit: { title: 'Audit Logs', exportCsv: 'Export CSV', userId: 'User ID', action: 'Action', resource: 'Resource', description: 'Description' } });
Object.assign(resources.es.translation, { audit: { title: 'Auditoría', exportCsv: 'Exportar CSV', userId: 'User ID', action: 'Acción', resource: 'Recurso', description: 'Descripción' } });
Object.assign(resources.de.translation, { audit: { title: 'Audit-Protokolle', exportCsv: 'CSV exportieren', userId: 'User ID', action: 'Aktion', resource: 'Ressource', description: 'Beschreibung' } });
Object.assign(resources.fr.translation, { audit: { title: "Journaux d’audit", exportCsv: 'Exporter CSV', userId: 'User ID', action: 'Action', resource: 'Ressource', description: 'Description' } });

// Export CSV page
Object.assign(resources.en.translation, {
  exportCsv: {
    title: 'CSV Export', mapping: 'Mapping Configuration', delimiter: 'Delimiter', includeHeaders: 'Include headers', availableFields: 'Available fields',
    saveConfig: 'Save configuration', shared: 'Shared', myConfigs: 'My configurations', own: 'Own', fieldsOrder: 'Fields order',
    saveChangesInConfig: 'Save changes in configuration', downloadCsv: 'Download CSV', confirmDeleteText: 'Are you sure you want to delete the configuration', editConfig: 'Edit configuration'
  }
});
Object.assign(resources.es.translation, {
  exportCsv: {
    title: 'Exportación a CSV', mapping: 'Configuración de Mapping', delimiter: 'Separador', includeHeaders: 'Incluir cabeceras', availableFields: 'Campos disponibles',
    saveConfig: 'Guardar configuración', shared: 'Compartida', myConfigs: 'Mis configuraciones', own: 'Propias', fieldsOrder: 'Orden de campos',
    saveChangesInConfig: 'Guardar cambios en configuración', downloadCsv: 'Descargar CSV', confirmDeleteText: '¿Seguro que quieres eliminar la configuración', editConfig: 'Editar configuración'
  }
});

Object.assign(resources.de.translation, {
  exportCsv: {
    title: 'CSV-Export', mapping: 'Zuordnungskonfiguration', delimiter: 'Trennzeichen', includeHeaders: 'Kopfzeilen einbeziehen', availableFields: 'Verfügbare Felder',
    saveConfig: 'Konfiguration speichern', shared: 'Geteilt', myConfigs: 'Meine Konfigurationen', own: 'Eigene', fieldsOrder: 'Feldreihenfolge',
    saveChangesInConfig: 'Änderungen in Konfiguration speichern', downloadCsv: 'CSV herunterladen', confirmDeleteText: 'Möchten Sie die Konfiguration wirklich löschen', editConfig: 'Konfiguration bearbeiten'
  }
});
Object.assign(resources.fr.translation, {
  exportCsv: {
    title: 'Export CSV', mapping: 'Configuration de mappage', delimiter: 'Séparateur', includeHeaders: 'Inclure les en-têtes', availableFields: 'Champs disponibles',
    saveConfig: 'Enregistrer la configuration', shared: 'Partagée', myConfigs: 'Mes configurations', own: 'Propres', fieldsOrder: 'Ordre des champs',
    saveChangesInConfig: 'Enregistrer les modifications dans la configuration', downloadCsv: 'Télécharger CSV', confirmDeleteText: 'Voulez-vous vraiment supprimer la configuration', editConfig: 'Modifier la configuration'
  }
});

// Config Profiles page
Object.assign(resources.en.translation, {
  profiles: {
    title: 'Environments', new: 'New environment', nextcloud: 'Nextcloud', externalService: 'External service', reportsService: 'Reports service',
    edit: 'Edit environment', delete: 'Delete environment', confirmDelete: 'Are you sure you want to delete the environment', nextcloudUrl: 'Nextcloud URL',
    externalServiceUrl: 'External service URL', reportsServiceUrl: 'Reports service URL', markDefault: 'Mark as default', testConnectivity: 'Test Connectivity'
  }
});
Object.assign(resources.es.translation, {
  profiles: {
    title: 'Entornos', new: 'Nuevo entorno', nextcloud: 'Nextcloud', externalService: 'Servicio externo', reportsService: 'Servicio informes',
    edit: 'Editar entorno', delete: 'Eliminar entorno', confirmDelete: '¿Seguro que deseas eliminar el entorno', nextcloudUrl: 'Nextcloud URL',
    externalServiceUrl: 'Servicio externo URL', reportsServiceUrl: 'Servicio informes URL', markDefault: 'Marcar como predeterminado', testConnectivity: 'Test Conectividad'
  }
});
Object.assign(resources.de.translation, {
  profiles: {
    title: 'Umgebungen', new: 'Neue Umgebung', nextcloud: 'Nextcloud', externalService: 'Externer Dienst', reportsService: 'Berichtsdienst',
    edit: 'Umgebung bearbeiten', delete: 'Umgebung löschen', confirmDelete: 'Möchten Sie die Umgebung wirklich löschen', nextcloudUrl: 'Nextcloud URL',
    externalServiceUrl: 'Externe Dienst-URL', reportsServiceUrl: 'Berichtsdienst-URL', markDefault: 'Als Standard markieren', testConnectivity: 'Konnektivität testen'
  }
});
Object.assign(resources.fr.translation, {
  profiles: {
    title: 'Environnements', new: 'Nouvel environnement', nextcloud: 'Nextcloud', externalService: 'Service externe', reportsService: 'Service des rapports',
    edit: 'Modifier l’environnement', delete: 'Supprimer l’environnement', confirmDelete: 'Voulez-vous vraiment supprimer l’environnement', nextcloudUrl: 'URL Nextcloud',
    externalServiceUrl: 'URL du service externe', reportsServiceUrl: 'URL du service des rapports', markDefault: 'Définir par défaut', testConnectivity: 'Tester la connectivité'
  }
});

// Excel Mapping pages
Object.assign(resources.en.translation, {
  excelMapping: {
    title: 'Excel Mapping Configurations', newConfig: 'New Configuration', createConfig: 'Create Configuration', emptyTitle: 'No configurations created',
    emptyDesc: 'Create your first mapping configuration to start processing Excel files', active: 'Active', inactive: 'Inactive', file: 'File', mappedFields: 'Mapped fields',
    loading: 'Loading configurations...', confirmDeleteText: 'Are you sure you want to delete the configuration', basicInfo: 'Basic Information', configName: 'Configuration name',
    activeConfig: 'Active configuration', markDefault: 'Mark as default', excelFile: 'Excel File', processing: 'Processing...', uploadExcel: 'Upload Excel File',
    columnsFound: 'Columns found', columns: 'Columns', fieldMapping: 'Field Mapping', addField: 'Add Field', targetField: 'Target Field', excelColumn: 'Excel Column',
    unmapped: 'Unmapped', defaultValue: 'Default value', required: 'Required', errors: {
      loadConfigs: 'Error loading configurations', processExcel: 'Error processing the Excel file', loadTargets: 'Error loading target fields', save: 'Error saving configuration',
      mustUpload: 'You must upload an Excel file', atLeastOneField: 'You must configure at least one mapping field', preview: 'Error loading preview'
    },
    previewTitle: 'Preview', refresh: 'Refresh', back: 'Back', configInfo: 'Configuration Information', status: 'Status', configuredFields: 'Configured Fields',
    defShort: 'def', mappedDataPreview: 'Mapped Data Preview', noPreviewData: 'No preview data available', showingNExamples: 'Showing {{count}} example records',
    validationSummary: 'Validation Summary', validRecords: 'valid records'
  }
});
/*
Object.assign(resources.en.translation, {
  upload: {
    confirm: {
      info: 'Do you want to start the upload and processing now?',
      excludeAndGenerate: 'Exclude duplicates and generate'
    }
  }
});
*/
Object.assign(resources.es.translation, {
  excelMapping: {
    title: 'Configuraciones de Mapeo Excel', newConfig: 'Nueva Configuración', createConfig: 'Crear Configuración', emptyTitle: 'No hay configuraciones creadas',
    emptyDesc: 'Crea tu primera configuración de mapeo para comenzar a procesar archivos Excel', active: 'Activa', inactive: 'Inactiva', file: 'Archivo', mappedFields: 'Campos mapeados',
    loading: 'Cargando configuraciones...', confirmDeleteText: '¿Estás seguro de que quieres eliminar la configuración', basicInfo: 'Información Básica', configName: 'Nombre de la configuración',
    activeConfig: 'Configuración activa', markDefault: 'Marcar como predeterminada', excelFile: 'Archivo Excel', processing: 'Procesando...', uploadExcel: 'Cargar Archivo Excel',
    columnsFound: 'Columnas encontradas', columns: 'Columnas', fieldMapping: 'Mapeo de Campos', addField: 'Agregar Campo', targetField: 'Campo Objetivo', excelColumn: 'Columna Excel',
    unmapped: 'Sin mapear', defaultValue: 'Valor por defecto', required: 'Requerido', errors: {
      loadConfigs: 'Error al cargar las configuraciones', processExcel: 'Error al procesar el archivo Excel', loadTargets: 'Error al cargar campos objetivo', save: 'Error al guardar la configuración',
      mustUpload: 'Debe cargar un archivo Excel', atLeastOneField: 'Debe configurar al menos un campo de mapeo', preview: 'Error al cargar la vista previa'
    },
    previewTitle: 'Vista Previa', refresh: 'Actualizar', back: 'Volver', configInfo: 'Información de la Configuración', status: 'Estado', configuredFields: 'Campos Configurados',
    defShort: 'def', mappedDataPreview: 'Vista Previa de Datos Mapeados', noPreviewData: 'No hay datos de vista previa disponibles', showingNExamples: 'Mostrando {{count}} registros de ejemplo',
    validationSummary: 'Resumen de Validación', validRecords: 'registros válidos'
  }
});
/*
Object.assign(resources.es.translation, {
  upload: {
    confirm: {
      info: '¿Quieres iniciar la carga y el procesamiento ahora?',
      excludeAndGenerate: 'Excluir duplicados y generar'
    }
  }
});
*/
Object.assign(resources.de.translation, {
  excelMapping: {
    title: 'Excel-Zuordnungskonfigurationen', newConfig: 'Neue Konfiguration', createConfig: 'Konfiguration erstellen', emptyTitle: 'Keine Konfigurationen erstellt',
    emptyDesc: 'Erstellen Sie Ihre erste Zuordnungskonfiguration, um Excel-Dateien zu verarbeiten', active: 'Aktiv', inactive: 'Inaktiv', file: 'Datei', mappedFields: 'Zugeordnete Felder',
    loading: 'Konfigurationen werden geladen...', confirmDeleteText: 'Möchten Sie die Konfiguration wirklich löschen', basicInfo: 'Grundlegende Informationen', configName: 'Konfigurationsname',
    activeConfig: 'Aktive Konfiguration', markDefault: 'Als Standard markieren', excelFile: 'Excel-Datei', processing: 'Verarbeitung...', uploadExcel: 'Excel-Datei hochladen',
    columnsFound: 'Gefundene Spalten', columns: 'Spalten', fieldMapping: 'Feldzuordnung', addField: 'Feld hinzufügen', targetField: 'Zielfeld', excelColumn: 'Excel-Spalte',
    unmapped: 'Nicht zugeordnet', defaultValue: 'Standardwert', required: 'Erforderlich', errors: {
      loadConfigs: 'Fehler beim Laden der Konfigurationen', processExcel: 'Fehler beim Verarbeiten der Excel-Datei', loadTargets: 'Fehler beim Laden der Zielfelder', save: 'Fehler beim Speichern der Konfiguration',
      mustUpload: 'Sie müssen eine Excel-Datei hochladen', atLeastOneField: 'Sie müssen mindestens ein Zuordnungsfeld konfigurieren', preview: 'Fehler beim Laden der Vorschau'
    },
    previewTitle: 'Vorschau', refresh: 'Aktualisieren', back: 'Zurück', configInfo: 'Konfigurationsinformationen', status: 'Status', configuredFields: 'Konfigurierte Felder',
    defShort: 'Std', mappedDataPreview: 'Zuordnungsdaten-Vorschau', noPreviewData: 'Keine Vorschaudaten verfügbar', showingNExamples: 'Zeige {{count}} Beispiel-Datensätze',
    validationSummary: 'Validierungsübersicht', validRecords: 'gültige Datensätze'
  }
});
Object.assign(resources.fr.translation, {
  excelMapping: {
    title: 'Configurations de mappage Excel', newConfig: 'Nouvelle configuration', createConfig: 'Créer une configuration', emptyTitle: 'Aucune configuration créée',
    emptyDesc: 'Créez votre première configuration de mappage pour commencer à traiter des fichiers Excel', active: 'Active', inactive: 'Inactive', file: 'Fichier', mappedFields: 'Champs mappés',
    loading: 'Chargement des configurations...', confirmDeleteText: 'Voulez-vous vraiment supprimer la configuration', basicInfo: 'Informations de base', configName: 'Nom de la configuration',
    activeConfig: 'Configuration active', markDefault: 'Définir par défaut', excelFile: 'Fichier Excel', processing: 'Traitement...', uploadExcel: 'Téléverser le fichier Excel',
    columnsFound: 'Colonnes trouvées', columns: 'Colonnes', fieldMapping: 'Mappage des champs', addField: 'Ajouter un champ', targetField: 'Champ cible', excelColumn: 'Colonne Excel',
    unmapped: 'Non mappé', defaultValue: 'Valeur par défaut', required: 'Requis', errors: {
      loadConfigs: 'Erreur lors du chargement des configurations', processExcel: "Erreur lors du traitement du fichier Excel", loadTargets: 'Erreur lors du chargement des champs cibles', save: 'Erreur lors de l’enregistrement de la configuration',
      mustUpload: 'Vous devez téléverser un fichier Excel', atLeastOneField: 'Vous devez configurer au moins un champ de mappage', preview: 'Erreur lors du chargement de l’aperçu'
    },
    previewTitle: 'Aperçu', refresh: 'Actualiser', back: 'Retour', configInfo: 'Informations de la configuration', status: 'Statut', configuredFields: 'Champs configurés',
    defShort: 'def', mappedDataPreview: 'Aperçu des données mappées', noPreviewData: 'Aucune donnée d’aperçu disponible', showingNExamples: 'Affichage de {{count}} enregistrements d’exemple',
    validationSummary: 'Résumé de la validation', validRecords: 'enregistrements valides'
  }
});
Object.assign(resources.de.translation, {
  upload: {
    title: 'Excel-Datei hochladen',
    mappingConfig: 'Zuordnungskonfiguration',
    selectMapping: 'Wählen Sie eine Zuordnungskonfiguration',
    selectedConfig: 'Ausgewählte Konfiguration',
    selectFile: 'Wählen Sie eine Excel-Datei zum Verarbeiten',
    ariaSelectFile: 'Excel-Datei auswählen',
    fileSelected: 'Datei ausgewählt',
    clickToSelect: 'Klicken Sie, um eine Datei auszuwählen',
    supportedFormats: 'Unterstützte Formate: .xlsx, .xls',
    size: 'Größe',
    processing: 'Datei wird verarbeitet...',
    processingShort: 'Verarbeitung...',
    uploadAndProcess: 'Hochladen und Verarbeiten',
    info: {
      title: 'Informationen zur Verarbeitung',
      supportedTitle: 'Unterstützte Formate',
      supportedDesc: 'Excel (.xlsx, .xls)',
      autoTitle: 'Automatische Verarbeitung',
      autoDesc: 'Daten werden automatisch beim Hochladen verarbeitet',
      resultsTitle: 'Ergebnisse',
      resultsDesc: 'Ergebnisse erscheinen nach der Verarbeitung im Dashboard',
    },
    confirm: {
      title: 'Verarbeitung bestätigen',
      subtitle: 'Daten werden mit der folgenden Konfiguration verarbeitet:',
      cta: 'Bestätigen und Verarbeiten',
      info: 'Durch die Bestätigung wird die Datei zum Server gesendet und gemäß der ausgewählten Zuordnungskonfiguration verarbeitet.',
      excludeAndGenerate: 'Duplikate ausschließen und generieren',
    },
    uploading: 'Hochladen...',
    checkExistence: 'Existenz prüfen (nif + template)',
    existenceFound: 'Es wurden bereits verarbeitete Kunden für das ausgewählte Template/Typ gefunden.',
    name: 'Name',
    description: 'Beschreibung',
    excelFile: 'Excel-Datei',
    fieldsCount: 'Konfigurierte Felder',
    fileToProcess: 'Zu verarbeitende Datei',
    processingService: 'Verarbeitungsdienst',
    externalService: 'Externer Dienst',
    externalServiceBackend: 'Wird an den im Backend konfigurierten Dienst gesendet',
    environment: 'Umgebung',
    notSelected: 'Nicht ausgewählt',
    errors: { noFile: 'Bitte wählen Sie eine Excel-Datei aus.', noMapping: 'Bitte wählen Sie eine Zuordnungskonfiguration aus.' },
  }
});

Object.assign(resources.fr.translation, {
  upload: {
    title: 'Téléverser un fichier Excel',
    mappingConfig: 'Configuration de mappage',
    selectMapping: 'Sélectionnez une configuration de mappage',
    selectedConfig: 'Configuration sélectionnée',
    selectFile: 'Sélectionnez un fichier Excel à traiter',
    ariaSelectFile: 'Sélectionner un fichier Excel',
    fileSelected: 'Fichier sélectionné',
    clickToSelect: 'Cliquez pour sélectionner un fichier',
    supportedFormats: 'Formats pris en charge : .xlsx, .xls',
    size: 'Taille',
    processing: 'Traitement du fichier...',
    processingShort: 'Traitement...',
    uploadAndProcess: 'Téléverser et traiter',
    info: {
      title: 'Informations sur le traitement',
      supportedTitle: 'Formats pris en charge',
      supportedDesc: 'Excel (.xlsx, .xls)',
      autoTitle: 'Traitement automatique',
      autoDesc: 'Les données sont traitées automatiquement lors du téléversement',
      resultsTitle: 'Résultats',
      resultsDesc: 'Les résultats apparaîtront dans le tableau de bord après le traitement',
    },
    confirm: {
      title: 'Confirmer le traitement',
      subtitle: 'Les données seront traitées avec la configuration suivante :',
      cta: 'Confirmer et traiter',
      info: 'En confirmant, le fichier sera envoyé au serveur pour traitement. Les données seront traitées selon la configuration de mappage sélectionnée.',
      excludeAndGenerate: 'Exclure les doublons et générer',
    },
    uploading: 'Téléversement...',
    checkExistence: 'Vérifier l\'existence (nif + template)',
    existenceFound: 'Des clients déjà traités pour le template/type sélectionné ont été trouvés.',
    name: 'Nom',
    description: 'Description',
    excelFile: 'Fichier Excel',
    fieldsCount: 'Champs configurés',
    fileToProcess: 'Fichier à traiter',
    processingService: 'Service de traitement',
    externalService: 'Service externe',
    externalServiceBackend: 'Il sera envoyé au service configuré dans le backend',
    environment: 'Environnement',
    notSelected: 'Non sélectionné',
    errors: { noFile: 'Veuillez sélectionner un fichier Excel.', noMapping: 'Veuillez sélectionner une configuration de mappage.' },
  }
});

// Resolver idioma inicial desde localStorage o navegador (languageOnly)
const savedLang = (() => {
  try { return localStorage.getItem('preferredLanguage') || undefined; } catch { return undefined; }
})();
const browserLang = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language.split('-')[0] : 'en';
const supported = ['en','es','de','fr'];
const initialLng = savedLang && supported.includes(savedLang) ? savedLang : (supported.includes(browserLang) ? browserLang : 'en');

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: initialLng,
    supportedLngs: supported,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
  });

export default i18n;


